<div class="success">
  <h1>Registration</h1>
  <h3>
      We have sent a verification link to your email, please follow steps outlined in the email to verify your account before logging in! It may take a few minutes for the email to reach your inbox, check your spam inbox if it does not appear!
  </h3>
</div>
